import React, { useState, useEffect } from 'react'
import { concourseId } from '../constants/activity-constants'

const useUrlIdRegister = () => {
  const [urlRegister, setUrlRegister] = useState('/registro')


  useEffect(() => {
    if(window){
      const pathName = window.location.pathname.slice(1, -1)
      setUrlRegister(`/registro/?url=${pathName}&id=${concourseId}`)
    }
  }, [])


  return urlRegister

}

export default useUrlIdRegister
